//签到
import signStates from './sign/states'
//表现
import showStates from './show/states'

//讨论
import discussStates from './discuss/states'
//问卷
import quesStates from './ques/states'
//互评
import mutualEvaluateStates from './mutualEvaluate/states'
//测验
import testStates from './test/states'

export default {
  //课中活动
  activityQuery: {
    courseList: ''
  },
  ...signStates, //签到
  ...showStates, //表现
  ...discussStates, //讨论
  ...quesStates, //问卷
  ...mutualEvaluateStates, //互评
  ...testStates, //测验
}
